import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { I } from '../lib/icons';

const ToastCtx = createContext(null);

export function ToastProvider({ children }) {
  const [toast, setToast] = useState(null);

  const show = useCallback((message, opts = {}) => {
    setToast({ message, type: opts.type || 'success', id: Date.now() });
  }, []);

  useEffect(() => {
    if (!toast) return;
    const t = setTimeout(() => setToast(null), toast.type === 'error' ? 4200 : 2800);
    return () => clearTimeout(t);
  }, [toast]);

  return (
    <ToastCtx.Provider value={{ show, success: (m) => show(m, { type: 'success' }), error: (m) => show(m, { type: 'error' }) }}>
      {children}
      {toast && (
        <div
          role="status"
          style={{
            position: 'fixed', bottom: 24, left: '50%',
            transform: 'translateX(-50%)', zIndex: 3000,
            background: '#1c2230', color: '#fff',
            padding: '10px 18px', borderRadius: 'var(--r-full)',
            display: 'flex', alignItems: 'center', gap: 10,
            fontSize: 13, fontWeight: 500,
            boxShadow: '0 10px 30px rgba(0,0,0,0.25)',
            animation: 'cd-toastIn 0.3s var(--ease)',
            maxWidth: 'calc(100vw - 32px)',
          }}
        >
          <span style={{
            width: 22, height: 22, borderRadius: '50%',
            background: toast.type === 'error' ? 'var(--danger)' : 'var(--success)',
            color: '#fff',
            display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
          }}>
            {toast.type === 'error' ? <I.x /> : <I.check />}
          </span>
          {toast.message}
        </div>
      )}
    </ToastCtx.Provider>
  );
}

export function useToast() {
  const ctx = useContext(ToastCtx);
  if (!ctx) {
    return { show: () => {}, success: () => {}, error: () => {} };
  }
  return ctx;
}
